import { Loader2 } from "lucide-react";

const LoadingScreen = () => {
  return (
    <div className="min-h-[50vh] lg:min-h-[70vh] w-full flex flex-col items-center justify-center bg-white rounded-xl my-4">
      <Loader2 className="w-12 h-12 animate-spin text-indigo-600 mb-4" />
      <p className="text-gray-600">Applying your slot holiday...</p>
      <p className="text-gray-500 text-sm mt-2">This will only take a moment</p>
    </div>
  );
};

export default LoadingScreen;
